// src/pages/Login.jsx
import React, { useEffect, useState, useRef } from 'react';
import NET from 'vanta/dist/vanta.net.min';
import * as THREE from 'three';
import { useNavigate } from 'react-router-dom';
import '../styles/login.css';

const API_URL = `${process.env.REACT_APP_API_URL}/api/auth`;

export default function Login() {
  const navigate    = useNavigate();
  const vantaRef    = useRef(null);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  // 1) ถ้ามี token+expiresAt เก่า และยังไม่หมดอายุ → ไป Dashboard เลย
  useEffect(() => {
    const token     = localStorage.getItem('token');
    const expiresAt = localStorage.getItem('expiresAt');
    if (token && expiresAt) {
      const expTime = new Date(expiresAt).getTime();
      if (Date.now() < expTime) {
        navigate('/dashboard/pg');
        return;
      }
      // หมดอายุแล้ว ลบทิ้ง
      localStorage.removeItem('token');
      localStorage.removeItem('expiresAt');
    }
  }, [navigate]);

  // 2) เริ่ม Vanta.js background
  useEffect(() => {
    const effect = NET({
      el: vantaRef.current,
      THREE,
      color: 0x00ffff,
      backgroundColor: 0x000000,
      points: 12.0,
      maxDistance: 25.0,
      spacing: 18.0,
    });
    return () => effect.destroy();
  }, []);

  // 3) custom cursor
  useEffect(() => {
    const cursor = document.getElementById('cursor');
    const onMove = e => {
      cursor.style.top  = `${e.clientY}px`;
      cursor.style.left = `${e.clientX}px`;
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mousedown', () => cursor.style.transform = 'scale(0.7)');
    document.addEventListener('mouseup',   () => cursor.style.transform = 'scale(1)');
    return () => document.removeEventListener('mousemove', onMove);
  }, []);

  // 4) VanillaTilt ให้กล่องฟอร์ม
  // useEffect(() => {
  //   const isDesktop = window.matchMedia('(pointer: fine)').matches;
  //   if (isDesktop) {
  //     VanillaTilt.init(document.querySelectorAll('.login-container'), {
  //       glare: true,
  //       "max-glare": 0.2,
  //       speed: 400,
  //     });
  //   }
  // }, []);

  // 5) ฟังก์ชันส่งข้อมูล
  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();

      if (!res.ok) {
        alert(data.msg || 'Login failed');
        return;
      }

      // เก็บ token + expiresAt ลง localStorage
      localStorage.setItem('token', data.token);
      localStorage.setItem('expiresAt', data.expiresAt);

      navigate('/dashboard/pg');
    } catch (err) {
      console.error('Login error:', err);
      alert('Network error: ' + err.message);
    }
  };

  return (
    <div className="login-page">
      {/* Vanta.js background */}
      <div ref={vantaRef} id="vantabg" />
      <div className="overlay scanlines" />
      <div className="overlay flicker" />
      <div id="cursor" />

      <div className="login-container">
        <img
          src="/assets/img/mm159_logo.png"
          alt="Site Logo"
          className="login-logo"
        />
        <h2>AI MM159</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
              placeholder="username"
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>
          <button type="submit">ဂိမ်းထဲဝင်မည်</button>
        </form>

        <p>
          အက်မင်ကို ဆက်သွယ်ရန်{' '}
          <a
            href="https://t.me/MM159bot"
            className="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Telegram
            </a>  
        </p>
      </div>
    </div>
  );
}

